<div class=" h-full rounded-lg border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-700 dark:bg-gray-900">
  <h3 class="hhh mb-4 text-lg font-semibold text-gray-900 dark:text-white">
    <i class="pi pi-calendar mr-2 text-blue-500"></i>
    {{ 'dashboard.todaysMetrics.title' | translate }}
  </h3>

  @if (isLoading()) {
    <div class="grid grid-cols-2 gap-4">
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="h-24 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"></div>
      }
    </div>
  } @else if (error()) {
    <div class="py-4 text-center">
      <p class="text-red-600 dark:text-red-400">{{ error() }}</p>
      <button
        class="mt-2 text-sm text-blue-600 hover:text-blue-800"
        (click)="loadTodaysMetrics()"
      >
        {{ 'common.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="grid grid-cols-2 gap-4 items-stretch">
      <!-- Check-ins -->
      <app-stat-card
        [value]="getCheckinDisplay()"
        [label]="'dashboard.todaysMetrics.checkins' | translate"
        icon="pi-sign-in"
        color="blue"
      >
      </app-stat-card>

      <!-- Check-outs -->
      <app-stat-card
        [value]="getCheckoutDisplay()"
        [label]="'dashboard.todaysMetrics.checkouts' | translate"
        icon="pi-sign-out"
        color="green"
      >
      </app-stat-card>

      <!-- Cleaning -->
      <app-stat-card
        [value]="getCleaningDisplay()"
        [label]="'dashboard.todaysMetrics.cleaning' | translate"
        icon="pi-sparkles"
        color="purple"
      >
      </app-stat-card>

      <!-- Expedia Bookings -->
      <app-stat-card
        [value]="getExpediaDisplay()"
        [label]="'dashboard.todaysMetrics.expedia' | translate"
        icon="pi-exclamation-triangle"
        color="amber"
      >
      </app-stat-card>
    </div>
  }
</div>
